import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { IDepositLoanTransactionRecordDto } from "../../../dtos/transactions/IDepositLoanTransactionRecordDto";
import { ISalaryTransactionRecordDto } from "../../../dtos/transactions/ISalaryTransactionRecordDto";

interface IProps {
  items: ISalaryTransactionRecordDto[];
}

export const SalaryTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="divisionId" dataType={"string"} caption="Division" />
          <Column width={150} dataField="accrualId" dataType={"string"} caption="Accrual" />
          <Column width={150} dataField="employeeId" dataType={"string"} caption="Employee" />
          <Column width={150} dataField="accountDtId" dataType={"string"} caption="Account Dt" />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company" />
          <Column width={150} dataField="month" dataType={"datetime"} caption="Month" />
          <Column width={150} dataField="amount" dataType={"number"} caption="Amount" />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
